const ZoneIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="81px"
            height="81px"
            viewBox="-0.5 -0.5 81 81"
        >
            <defs />
            <g>
                <image
                    x="-0.5"
                    y="-0.5"
                    width="80"
                    height="80"
                    xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjEwMHB4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAwIDEwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPiYjeGE7PHN0eWxlIHR5cGU9InRleHQvY3NzIj4mI3hhOwkuc3Qwe2ZpbGw6I0RFRUFGMDtzdHJva2U6IzJCNEU2OTtzdHJva2Utd2lkdGg6MjtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9JiN4YTs8L3N0eWxlPiYjeGE7PGcgaWQ9Imdyb3VwNDc4LTE1M18xNF8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzMS45NTUsLTMxNi4wNjMpIj4mI3hhOwk8dGl0bGU+U2hlZXQuNDc4PC90aXRsZT4mI3hhOwk8ZyBpZD0ic2hhcGU0NzktMTU0XzE0XyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCwtMi42Mjc4NykiPiYjeGE7CQk8dGl0bGU+U2hlZXQuNDc5PC90aXRsZT4mI3hhOwkJPHBhdGggY2xhc3M9InN0MCIgZD0iTS0xNDkuNywzOTguMWM4LjUsMCwxNS40LTcuNiwxNS40LTE3LjFjMC04LjEtNS4xLTE0LjktMTEuOS0xNi42Yy0wLjEtMTcuMS0xMi43LTMxLTI4LjItMzEgICAgYy0xMC42LDAtMTkuOSw2LjUtMjQuNywxNi4yYy0xLjUtMC43LTMuMS0xLjEtNC44LTEuMWMtNi4xLDAtMTEuMSw1LjEtMTEuOSwxMS42Yy03LjksMS43LTEzLjksOS41LTEzLjksMTguOCAgICBjMCwxMC42LDcuOCwxOS4yLDE3LjMsMTkuMkMtMjA5LjcsMzk4LjEtMTUxLjUsMzk4LjEtMTQ5LjcsMzk4LjF6Ii8+JiN4YTsJPC9nPiYjeGE7PC9nPiYjeGE7PC9zdmc+"
                    preserveAspectRatio="none"
                />
            </g>
        </svg>
    );
};

export default ZoneIcon;
